import React, { Component } from 'react';
import jwt_decode from "jwt-decode";
import Slider from "react-slick";
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import { toast } from 'react-toastify';

let isMobile = false;
if (window.innerWidth <= 760) isMobile = true;

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            categorylist: [],
            listitallgame: [],

            activeProviderIndex: 0,
            activeProvider: null,
            activeFilter: "ALL",
            searchText: '',
            showDropdown: false,
            sortOpen: false,
            sortType: 'popular',

            loadingProvider: false,
            loadingGame: false,

            slideIndex: 0,

            playerid: null,
            user_id: null,
            username: null,
            point: null,
            loginstate: false,
            firstname: null,
            lastname: null,
            alert: null
        };
    }

    async componentDidMount() {
        this.checklogin();
        // อ่าน partner จาก URL path เช่น /casino/SEXY → "SEXY"
        const urlPartner = window.location.pathname.split('/')[2] || '';
        await this.getCasinoProviderList(urlPartner);

        // สไลด์รูปอัตโนมัติ (แทนวิดีโอ)
        this._slideTimer = setInterval(() => {
            this.setState(p => ({ slideIndex: (p.slideIndex + 1) % this.SLIDE_IMAGES.length }));
        }, 4000);
    }

    componentWillUnmount() {
        if (this._slideTimer) clearInterval(this._slideTimer);
    }

    // รูปสไลด์ (แทนวิดีโอเดิม)
    SLIDE_IMAGES = [
        "https://s3.newworld.center/image/290af8ea-ab15-42b7-82eb-27d28edd3d69.webp",
        "https://s3.newworld.center/image/ad24febe-e900-415b-9cce-1df3e76ecb80.webp",
        "https://s3.newworld.center/image/0021b9d2-7721-4c02-a88b-47531c7c8061.webp"
    ];

    checklogin() {
        var token = localStorage.getItem('auth_token');

        if (token != null) {
            var decoded = jwt_decode(token);

            this.setState({
                user_id: decoded.message.playerid,
                playerid: decoded.message.member_id,
                username: decoded.message.username || decoded.message.Username || decoded.message.member_id || decoded.message.playerid,
                firstname: decoded.message.firstname,
                lastname: decoded.message.lastname,
                point: decoded.message.Point,
                loginstate: true
            });
        } else {
            this.setState({
                loginstate: false
            });
        }
    }

    notify = async (mode, msg) => {
        if (mode == "success") {
            await toast.success(msg, { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
        } else if (mode == "warning") {
            await toast.warning(msg, { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
        } else if (mode == "error") {
            await toast.error(msg, { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
        } else if (mode == "info") {
            await toast.info(msg, { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
        }
    };

    setCache(cacheKey, data, minute = 10) {
        localStorage.setItem(
            cacheKey,
            JSON.stringify({
                timestamp: Date.now(),
                expire: minute * 60 * 1000,
                data: data
            })
        );
    }

    getCache(cacheKey) {
        const cached = localStorage.getItem(cacheKey);

        if (!cached) return null;

        try {
            const parsed = JSON.parse(cached);

            if (parsed && Date.now() - parsed.timestamp < parsed.expire) {
                return parsed.data;
            }

            localStorage.removeItem(cacheKey);
            return null;
        } catch (err) {
            localStorage.removeItem(cacheKey);
            return null;
        }
    }

    _pickProvider(categorylist, urlPartner) {
        if (!categorylist.length) return { provider: null, index: 0 };
        if (urlPartner) {
            const idx = categorylist.findIndex(p =>
                this.getProviderCode(p).toLowerCase() === urlPartner.toLowerCase()
            );
            if (idx !== -1) return { provider: categorylist[idx], index: idx };
        }
        return { provider: categorylist[0], index: 0 };
    }

    async getCasinoProviderList(urlPartner = '') {
        const cacheKey = `casino_provider_state_2_${Systems}`;
        const cachedData = this.getCache(cacheKey);

        if (cachedData) {
            const categorylist = Array.isArray(cachedData) ? cachedData : [];
            const { provider, index } = this._pickProvider(categorylist, urlPartner);

            this.setState({ categorylist, activeProvider: provider, activeProviderIndex: index });
            if (provider) await this.getCasinoGameByProvider(provider);
            return;
        }

        this.setState({ loadingProvider: true });

        await instance
            .post("/api/v1/tabgamelist", {
                state: "2",
                System: Systems
            })
            .then(async (res) => {
                if (res.data.status === 200) {
                    const categorylist = Array.isArray(res.data.message) ? res.data.message : [];
                    const { provider, index } = this._pickProvider(categorylist, urlPartner);

                    this.setCache(cacheKey, categorylist, 180);
                    this.setState({ categorylist, activeProvider: provider, activeProviderIndex: index });
                    if (provider) await this.getCasinoGameByProvider(provider);
                }
            })
            .catch((err) => {
                console.log("[CASINO_PROVIDER_ERROR]", err);
            })
            .finally(() => {
                this.setState({ loadingProvider: false });
            });
    }

    selectProviderByDropdown = async (provider, index) => {
        const code = this.getProviderCode(provider);
        // update URL โดยไม่ reload หน้า
        window.history.pushState(null, '', `/casino/${code}`);
        this.setState({ activeProvider: provider, activeProviderIndex: index, showDropdown: false });
        await this.getCasinoGameByProvider(provider);
    }

    async getCasinoGameByProvider(providerItem) {
        const partner = this.getProviderCode(providerItem);

        if (!partner) return;

        await this.getgame("casino", partner, "999");
    }

    async getgame(typepage, partner, state = "999") {
        if (!partner) return;

        const cacheKey = `casino_gamelist_${state}_${Systems}_${partner}_${typepage}`;
        const cachedData = this.getCache(cacheKey);

        if (cachedData) {
            this.setState({
                listitallgame: Array.isArray(cachedData) ? cachedData : []
            });
            return;
        }

        this.setState({ loadingGame: true });

        await instance
            .post("/api/v1/tabgamelist", {
                state: state,
                System: Systems,
                partner: partner,
                game: typepage
            })
            .then((res) => {
                if (res.data.status === 200) {
                    const gameData = Array.isArray(res.data.message) ? res.data.message : [];

                    this.setCache(cacheKey, gameData, 10);

                    this.setState({
                        listitallgame: gameData
                    });
                } else {
                    this.setState({
                        listitallgame: []
                    });
                }
            })
            .catch((err) => {
                console.log("[GET_CASINO_GAME_ERROR]", err);

                this.setState({
                    listitallgame: []
                });
            })
            .finally(() => {
                this.setState({ loadingGame: false });
            });
    }

    redeem = async (e, gameIdx, partner) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        var userAgent = navigator.userAgent;
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

        await this.checklogin();

        if (!this.state.loginstate) {
            await this.notify("error", "คุณยังไม่ได้เข้าสู่ระบบ");
            return;
        }

        const username = this.state.username || this.state.user_id || this.state.playerid;

        if (!username) {
            await this.notify("error", "ไม่พบข้อมูลผู้เล่น กรุณาเข้าสู่ระบบใหม่");
            return;
        }

        if (!gameIdx || !partner) {
            await this.notify("error", "ไม่พบข้อมูลเกม กรุณาลองใหม่");
            return;
        }

        await instance
            .post("/api/v1/tablauncher", {
                gameId: gameIdx,
                partner: partner,
                playerUsername: username,
                isMobile: isMobile,
                System: Systems,
                demo: false
            })
            .then((res) => {
                if (res.data.status === 200) {
                    var launcher = res.data.message.launcher;

                    if (launcher !== undefined) {
                        if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
                            window.location.href = launcher.mobile;
                        } else {
                            if (!isMobile) {
                                window.open(launcher.desktop || launcher.mobile, "_blank", "height=1000,width=1000");
                            } else {
                                window.open(launcher.mobile || launcher.desktop);
                            }
                        }
                    } else {
                        this.notify("error", "ขณะนี้เกมมีปัญหากรุณารอซักครู่");
                    }
                } else {
                    this.notify("error", res.data.message || "เปิดเกมไม่สำเร็จ");
                }
            })
            .catch((err) => {
                console.log("[LAUNCH_CASINO_GAME_ERROR]", err);
                this.notify("error", "ขณะนี้เกมมีปัญหากรุณารอซักครู่");
            });
    };

    redeemdemo = async (e, gameIdx, partner) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        var userAgent = navigator.userAgent;
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

        if (!gameIdx || !partner) {
            await this.notify("error", "ไม่พบข้อมูลเกม กรุณาลองใหม่");
            return;
        }

        await instance
            .post("/api/v1/tablauncher", {
                gameId: gameIdx,
                partner: partner,
                playerUsername: this.state.username || this.state.user_id || this.state.playerid || "demo",
                isMobile: isMobile,
                System: Systems,
                demo: true
            })
            .then((res) => {
                if (res.data.status === 200) {
                    var launcher = res.data.message.launcher;

                    if (launcher !== undefined) {
                        if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
                            window.location.href = launcher.mobile;
                        } else {
                            if (!isMobile) {
                                window.open(launcher.desktop || launcher.mobile, "_blank", "height=1000,width=1000");
                            } else {
                                window.open(launcher.mobile || launcher.desktop);
                            }
                        }
                    } else {
                        this.notify("error", "ขณะนี้เกมเดโมมีปัญหากรุณารอซักครู่");
                    }
                } else {
                    this.notify("error", res.data.message || "เปิดเกมเดโมไม่สำเร็จ");
                }
            })
            .catch((err) => {
                console.log("[LAUNCH_CASINO_DEMO_ERROR]", err);
                this.notify("error", "ขณะนี้เกมเดโมมีปัญหากรุณารอซักครู่");
            });
    };

    getProviderName = (item) => {
        return (
            item?.description ||
            item?.Description ||
            item?.proname ||
            item?.providername ||
            item?.ProviderName ||
            item?.name ||
            item?.Name ||
            item?.title ||
            item?.Title ||
            "-"
        );
    };

    getGameName = (item) => {
        return (
            item?.description ||
            item?.Description ||
            item?.gamename ||
            item?.game_name ||
            item?.GameName ||
            item?.name ||
            item?.Name ||
            item?.title ||
            item?.Title ||
            "-"
        );
    };

    getProviderCode = (item) => {
        return (
            item?.partner ||
            item?.Partner ||
            item?.providercode ||
            item?.provider_code ||
            item?.ProviderCode ||
            item?.code ||
            item?.Code ||
            ""
        );
    };

    getGameCode = (item) => {
        return (
            item?.gameid ||
            item?.gameId ||
            item?.game_id ||
            item?.gamecode ||
            item?.GameCode ||
            item?.code ||
            item?.Code ||
            ""
        );
    };

    getProviderImage = (item) => {
        return (
            item?.imagesec ||
            ""
        );
    };

    getGameImage = (item) => {
        return (
            item?.image ||
            item?.Image ||
            item?.img ||
            item?.img_path ||
            item?.imagepath ||
            item?.imagesec ||
            item?.imgprovidor ||
            item?.selectimg ||
            ""
        );
    };

    getGameCategory = (item) => {
        const text = String(
            item?.categories ||
            item?.category ||
            item?.Category ||
            item?.gamecategory ||
            item?.game_category ||
            item?.type ||
            item?.Type ||
            item?.description ||
            item?.Description ||
            ""
        ).toLowerCase();

        if (text.includes("baccarat") || text.includes("บาคาร่า")) return "BACCARAT";
        if (text.includes("roulette") || text.includes("รูเล็ต")) return "ROULETTE";
        if (text.includes("sicbo") || text.includes("sic bo") || text.includes("ไฮโล")) return "SICBO";
        if (text.includes("blackjack") || text.includes("แบล็คแจ็ค")) return "BLACKJACK";
        if (text.includes("dragon") || text.includes("tiger") || text.includes("เสือ") || text.includes("มังกร")) return "DRAGONTIGER";

        return "OTHER";
    };

    selectProvider = async (item, index) => {
        this.setState({
            activeProvider: item,
            activeProviderIndex: index,
            activeFilter: "ALL",
            listitallgame: []
        });

        await this.getCasinoGameByProvider(item);
    };

    setFilter = (filter) => {
        this.setState({
            activeFilter: filter
        });
    };

    getFilteredGames = () => {
        const { listitallgame, activeFilter, searchText } = this.state;

        let rows = Array.isArray(listitallgame) ? listitallgame : [];

        if (activeFilter !== "ALL") {
            rows = rows.filter((item) => this.getGameCategory(item) === activeFilter);
        }

        if (searchText && searchText.trim() !== "") {
            const keyword = searchText.trim().toLowerCase();
            rows = rows.filter((item) => {
                const name = this.getGameName(item).toLowerCase();
                const provider = this.getProviderCode(item).toLowerCase();
                return name.includes(keyword) || provider.includes(keyword);
            });
        }

        return rows;
    };

    getMockBestLiveGames = () => {
        const mockImages = [
            {
                name: "PK8 Salon Privé Baccarat",
                provider: "Evolution Gaming",
                img: "/build/web/igame-index-lobby-wm/img/BK8SalonPrivBaccarat.png"
            },
            {
                name: "Lightning Roulette",
                provider: "Evolution Gaming",
                img: "/build/web/igame-index-lobby-wm/img/lightningroulette.png"
            },
            {
                name: "Mega Ball",
                provider: "Evolution Gaming",
                img: "/build/web/igame-index-lobby-wm/img/megaball.png"
            },
            {
                name: "First Person Baccarat",
                provider: "Evolution Gaming",
                img: "/build/web/igame-index-lobby-wm/img/firstpersonbaccarat.png"
            },
            {
                name: "PK8 Baccarat 1",
                provider: "PPLiveCasino",
                img: "/build/web/igame-index-lobby-wm/img/BK8Baccarat1.png"
            },
            {
                name: "Dream Catcher",
                provider: "Evolution Gaming",
                img: "/build/web/igame-index-lobby-wm/img/dreamcatcher.png"
            }
        ];

        return mockImages;
    };

    renderProviderItem = (item, index) => {
        const name = this.getProviderName(item);
        const code = this.getProviderCode(item);
        const img = this.getProviderImage(item);
        const isActive = this.state.activeProviderIndex === index;

        return (
            <li
                key={`${code || name}-${index}`}
                className={`tab-header ${isActive ? "active" : "false"}`}
                data-provider-name={name}
                data-provider-code={code}
                onClick={() => this.selectProvider(item, index)}
            >
                {index < 5 ? <p className="float-dot hot-provider">ฮอต</p> : null}

                <div className="tab-inner">
                    {img ? (
                        <img
                            src={img}
                            alt={name}
                            className="sub-icon"
                        />
                    ) : (
                        <span className="sub-icon">{String(code || name).substring(0, 2)}</span>
                    )}

                    <span>{name}</span>
                </div>
            </li>
        );
    };

    renderTabHeader = (code, text) => {
        const isActive = this.state.activeFilter === code;

        return (
            <div
                className={`tab-header ${isActive ? "active" : ""}`}
                onClick={() => this.setFilter(code)}
            >
                {text}
            </div>
        );
    };

    /* แท็บกรองหมวด "มือถือ" — โครงสร้าง bk8 (.tab-header.filter-header) ให้ CSS เดิมจับ = แท็บแนวนอน
       แยกจาก renderTabHeader (desktop) ไม่ให้กระทบกัน */
    renderMobileFilterTab = (code, text, category) => {
        const isActive = this.state.activeFilter === code;

        return (
            <div
                className={`tab-header filter-header ${isActive ? "active" : ""}`}
                data-game-category-name={category}
                onClick={() => this.setFilter(code)}
                style={{ border: 'none', background: isActive ? undefined : 'transparent' }}
            >
                {text}
            </div>
        );
    };

    renderWinnerBox = () => {
        const providerIconMap = {
            "SA Gaming":        "/build/admin/img/lobby_main/sa-gaming-logo-circle-notext.png",
            "Evolution Gaming": "/build/admin/img/lobby_main/eg-logo-circle-notext.png",
            "AE Casino":        "/build/admin/img/lobby_main/ae-sexy-logo-circle-notext.png",
            "WM Casino":        "/build/admin/img/lobby_main/wm-logo-circle-notext.png",
            "Dream Gaming":     "/build/admin/img/lobby_main/dream-gaming-logo-circle-notext.png",
            "AllBet":           "/build/admin/img/lobby_main/allbet-logo-circle-notext.png",
        };

        const winners = [
            { provider: "SA Gaming",        game: "SIC BO",       username: "*at*pa*11",  amount: "2,008,756.00" },
            { provider: "Evolution Gaming", game: "Baccarat",     username: "*o****y*h*", amount: "7,984,959.00" },
            { provider: "AE Casino",        game: "Baccarat",     username: "n*hn*h1*",   amount: "4,856,217.00" },
            { provider: "SA Gaming",        game: "Baccarat",     username: "y*n*4*8*3*", amount: "2,073,354.00" },
            { provider: "WM Casino",        game: "Baccarat",     username: "p*k*9*1*",   amount: "1,542,890.00" },
            { provider: "Dream Gaming",     game: "Dragon Tiger", username: "t*h*l*2*",   amount: "3,217,445.00" },
        ];

        return (
            <div className="winner-container">
                <p className="title">ผู้ชนะสูงสุดของเดือน</p>

                <div className="winner-content">
                    <Slider
                        className="slider winner-box"
                        vertical={true}
                        dots={false}
                        arrows={false}
                        infinite={true}
                        autoplay={true}
                        autoplaySpeed={2200}
                        speed={500}
                        slidesToShow={3}
                        slidesToScroll={1}
                    >
                        {winners.map((row, index) => (
                            <div className="main-box" key={`winner-${index}`}>
                                <div className="img-container">
                                    <img
                                        src={providerIconMap[row.provider] || ""}
                                        alt={row.provider}
                                        className="provider-icon"
                                        onError={(e) => { e.target.style.display = 'none'; }}
                                    />
                                    <span>{row.provider} / {row.game}</span>
                                </div>

                                <div className="name">
                                    <span>{row.username}</span>
                                </div>

                                <div className="amount">
                                    <span>{row.amount}</span>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        );
    };





    renderGameCard = (game, index) => {
        const name = this.getGameName(game);
        const gameId = this.getGameCode(game);
        const partner = this.getProviderCode(game);
        const img = this.getGameImage(game);

        return (
            <div
                className="item-columns"
                key={`${partner}-${gameId}-${index}`}
                data-game-name={name}
                data-game-code={gameId}
                onClick={(e) => this.redeem(e, gameId, partner)}
            >
                <picture>
                    <source type="image/webp" srcSet={img} />
                    <img src={img} alt={name} effect="opacity" loading="lazy" />
                </picture>

                <div className="bn-desc">
                    <p className="name">{name}</p>

                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 90 90"
                        className=""
                        width="100%"
                        height="100%">
                        <g className="D-referral-important">
                            <path d="M45,0C20.1,0,0,20.1,0,45c0,24.9,20.1,45,45,45c24.9,0,45-20.1,45-45C90,20.1,69.9,0,45,0z M50.6,70.9 c0,3.1-2.5,5.6-5.6,5.6s-5.6-2.5-5.6-5.6V36.2c0-3.1,2.5-5.6,5.6-5.6s5.6,2.5,5.6,5.6V70.9z M45,24.7c-3.1,0-5.6-2.5-5.6-5.6 c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6C50.6,22.2,48.1,24.7,45,24.7z" />
                        </g>
                    </svg>
                </div>

                <div className="btn-container">
                    <button
                        type="button"
                        className="casino-play-btn"
                        onClick={(e) => this.redeem(e, gameId, partner)}
                    >
                        เล่น
                    </button>
                </div>
            </div>
        );
    };

    /* การ์ดเกมคาสิโน "มือถือ" — โครงสร้าง .game-box แบบ bk8 (ให้ CSS เดิมในบิลด์มาจับ)
       แยกจาก renderGameCard (desktop) ไม่ให้กระทบกัน */
    renderMobileGameCard = (game, index) => {
        const name = this.getGameName(game);
        const gameId = this.getGameCode(game);
        const partner = this.getProviderCode(game);
        const img = this.getGameImage(game);

        return (
            <div
                className="game-box"
                key={`mgame-${partner}-${gameId}-${index}`}
                data-game-name={name}
                data-game-code={gameId}
                onClick={(e) => this.redeem(e, gameId, partner)}
                style={{ cursor: 'pointer' }}
            >
                <div className="game-img-wrapper">
                    <picture>
                        <source type="image/webp" srcSet={img} />
                        <img src={img} alt={name} effect="opacity" loading="lazy" />
                    </picture>
                </div>
                <div className="game-details">
                    <div className="game-name-info">
                        <p className="game-name">{name}</p>
                    </div>
                    <div className="game-others-info"></div>
                </div>
            </div>
        );
    };




    renderVideoBox = () => {
        const { slideIndex } = this.state;
        const imgs = this.SLIDE_IMAGES;

        return (
            <div className="video-container casino-slide-container" style={{ position: 'relative', overflow: 'hidden', borderRadius: 12 }}>
                {imgs.map((src, i) => (
                    <img
                        key={i}
                        src={src}
                        alt={`slide-${i + 1}`}
                        loading="lazy"
                        style={{
                            position: i === 0 ? 'relative' : 'absolute',
                            top: 0, left: 0,
                            width: '100%',
                            height: i === 0 ? 'auto' : '100%',
                            objectFit: 'cover',
                            display: 'block',
                            opacity: i === slideIndex ? 1 : 0,
                            transition: 'opacity .8s ease-in-out',
                            zIndex: i === slideIndex ? 2 : 1
                        }}
                    />
                ))}

                <div
                    style={{
                        position: 'absolute', bottom: 10, left: 0, right: 0,
                        display: 'flex', justifyContent: 'center', gap: 7, zIndex: 3
                    }}
                >
                    {imgs.map((_, i) => (
                        <span
                            key={i}
                            onClick={() => this.setState({ slideIndex: i })}
                            style={{
                                width: i === slideIndex ? 20 : 8, height: 8,
                                borderRadius: 8, cursor: 'pointer',
                                background: i === slideIndex ? '#ffffff' : 'rgba(255,255,255,.55)',
                                transition: 'width .3s, background .3s'
                            }}
                        />
                    ))}
                </div>
            </div>
        );
    };

    renderBestLiveGame = (game, index) => {
        return (
            <div key={`best-live-${index}`}>
                <div className="live-casino-game-card">
                    <div className="live-casino-game-img">
                        <img src={game.img} alt={game.name} loading="lazy" />
                    </div>

                    <div className="live-casino-game-name">{game.name}</div>
                    <div className="live-casino-provider">{game.provider}</div>
                    <span className="float-dot hot-provider">ฮอต</span>
                </div>
            </div>
        );
    };

    renderBestLiveSlider = () => {
        // ดึงเกมจริงจาก state (เหมือนการ์ดเกมอื่น) → กดแล้ว launch ได้จริงเหมือนหน้าแรก
        const allGames = this.getFilteredGames();
        const rows = allGames.slice(0, 12);
        const providerName = this.state.activeProvider ? this.getProviderName(this.state.activeProvider) : 'คาสิโนสด';

        if (!rows.length) return null;

        return (
            <div className="best-live-games-container">
                <section className="live-casino-slider-section">
                    <div className="_homeTitleSection_28h8m_1">
                        <p className="_homeTitle_28h8m_1">
                            คาสิโนออนไลน์สดที่ดีที่สุด
                        </p>
                    </div>

                    <Slider
                        className="live-casino-slider"
                        dots={false}
                        arrows={true}
                        infinite={false}
                        speed={450}
                        slidesToShow={5}
                        slidesToScroll={1}
                        responsive={[
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 4
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 2
                                }
                            }
                        ]}
                    >
                        {rows.map((game, index) => {
                            const name = this.getGameName(game);
                            const gameId = this.getGameCode(game);
                            const partner = this.getProviderCode(game);
                            const img = this.getGameImage(game);
                            return (
                                <div key={`best-live-${partner}-${gameId}-${index}`}>
                                    <div
                                        className="live-casino-slider-container"
                                        onClick={(e) => this.redeem(e, gameId, partner)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="live-casino-slider-img-warpper">
                                            <picture>
                                                <source type="image/webp" srcSet={img} />
                                                <img src={img} alt={name} loading="lazy" />
                                            </picture>
                                            <div className="btn-container">
                                                <button
                                                    aria-label="launch-game"
                                                    className="live-casino-slider-play-btn"
                                                    onClick={(e) => this.redeem(e, gameId, partner)}
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 448 512"
                                                        width="1em"
                                                        height="1em"
                                                    >
                                                        <path d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="live-casino-slider-content">
                                            <div className="row-1">
                                                <p className="casino-name">{name}</p>
                                                <p className="hot-icon">ฮอต</p>
                                            </div>
                                            <p className="casino-type">{providerName}</p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </Slider>
                </section>
            </div>
        );
    };

    renderSummaryInfo = () => {
        return (
            <div className="provider-summary-info-container">
                <div className="summary">
                    <div className="number">150%</div>
                    <div className="title">โบนัสต้อนรับสมาชิกใหม่</div>
                </div>

                <div className="summary">
                    <div className="number">THB 8,000</div>
                    <div className="title">โบนัสคุ้มครองรายสัปดาห์</div>
                </div>

                <div className="summary">
                    <div className="number">คาสิโนคริปโต อันดับ1</div>
                    <div className="title">ได้รับอนุญาตอย่างถูกต้องที่ในเอเชีย</div>
                </div>

                <div className="summary">
                    <div className="standard-button-contaienr summary-info-btn-container">
                        <div className="standard-submit-button">
                            <span>เล่นเลยตอนนี้</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const isMobile = window.innerWidth <= 760;
        const { categorylist, loadingProvider, loadingGame } = this.state;
        const games = this.getFilteredGames();

        const sideGames = games.slice(0, 6);
        const bottomGames = games.slice(6, 9);

        /* ─── MOBILE LAYOUT ─── */
        if (isMobile) {
            const { activeProvider, searchText, showDropdown, categorylist } = this.state;
            const providerName = activeProvider ? this.getProviderName(activeProvider) : 'คาสิโนสด';
            const providerImg  = activeProvider ? this.getProviderImage(activeProvider) : '';
            const hotGames = games.slice(0, 6);
            const sortType = this.state.sortType;
            const sortLabelMap = { popular: 'เป็นที่นิยม', az: 'ชื่อ A-Z', za: 'ชื่อ Z-A' };
            const mainGames = sortType === 'popular'
                ? games
                : [...games].sort((a, b) => {
                    const na = this.getGameName(a).toLowerCase();
                    const nb = this.getGameName(b).toLowerCase();
                    return sortType === 'az' ? na.localeCompare(nb) : nb.localeCompare(na);
                });

            const providerCode = activeProvider ? this.getProviderCode(activeProvider) : '';

            return (
                <div className="casino-mobile-wrapper">

                    {/* ── BK8-style nav header ── */}
                    <nav className="mobile-nav header-grey">
                        <div className="col-left">
                            {/* Back arrow */}
                            <svg
                                className="menu-icon beta-back"
                                onClick={() => window.history.back()}
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="24" height="24"
                                fill="currentColor"
                            >
                                <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
                            </svg>

                            {/* Provider icon */}
                            {activeProvider && (
                                <div className={`provider-icon C-${providerCode}`}>
                                    {providerImg
                                        ? <img src={providerImg} alt={providerName} />
                                        : <span>{providerName.slice(0, 2)}</span>
                                    }
                                </div>
                            )}
                        </div>

                        <div className="col-right">
                            <div>
                                <div
                                    id="dropdownBtn"
                                    className={`standard-select${showDropdown ? ' isOpen' : ''}`}
                                    onClick={() => this.setState({ showDropdown: !showDropdown })}
                                >
                                    <span className="nav-title">{providerName}</span>
                                    <span className="standard-select-arrow"></span>
                                </div>
                            </div>
                        </div>
                    </nav>

                    {/* ── Provider dropdown overlay ── */}
                    {showDropdown && (
                        <div
                            className="casino-mobile-provider-overlay"
                            onClick={() => this.setState({ showDropdown: false })}
                        >
                            <div
                                className="casino-mobile-provider-dropdown-list"
                                onClick={e => e.stopPropagation()}
                            >
                                {categorylist.map((p, idx) => {
                                    const name = this.getProviderName(p);
                                    const code = this.getProviderCode(p);
                                    const img  = this.getProviderImage(p);
                                    const isActive = this.state.activeProviderIndex === idx;
                                    return (
                                        <div
                                            key={`dd-${code}-${idx}`}
                                            className={`casino-mobile-dd-item${isActive ? ' active' : ''}`}
                                            onClick={() => this.selectProviderByDropdown(p, idx)}
                                        >
                                            <div className="casino-mobile-dd-logo">
                                                {img
                                                    ? <img src={img} alt={name} />
                                                    : <span>{name.slice(0, 2)}</span>
                                                }
                                            </div>
                                            <span className="casino-mobile-dd-name">{name}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {/* ── เนื้อหา casino มือถือ ครอบใน .m-provider-content-container ตาม bk8 (slider + provider-content) ── */}
                    <div className="m-provider-content-container m-casino-container" style={{ background: '#ffffff' }}>

                    {/* ── Hot games slider (โครงสร้าง bk8 .live-casino-slider-section) ── */}
                    {hotGames.length > 0 && (
                        <div className="best-game-container">
                        <section className="live-casino-slider-section mobile-live-casino-slider-section">
                            <div className="_homeTitleSection_28h8m_1">
                                <p className="_homeTitle_28h8m_1" style={{ color: '#1a1a1a' }}>คาสิโนออนไลน์สดที่ดีที่สุด</p>
                            </div>
                            <div className="live-casino-slider">
                                <div className="live-casino-slider-wrapper">
                                    {hotGames.map((game, index) => {
                                        const name = this.getGameName(game);
                                        const gameId = this.getGameCode(game);
                                        const partner = this.getProviderCode(game);
                                        const img = this.getGameImage(game);
                                        return (
                                            <div
                                                key={`hot-${index}`}
                                                className="live-casino-slider-container"
                                                onClick={(e) => this.redeem(e, gameId, partner)}
                                                style={{ cursor: 'pointer', background: '#ffffff' }}
                                            >
                                                <div className="live-casino-slider-img-warpper">
                                                    <picture>
                                                        <source type="image/webp" srcSet={img} />
                                                        <img src={img} alt={name} loading="lazy" />
                                                    </picture>
                                                    <div className="btn-container">
                                                        <button aria-label="launch-game" className="live-casino-slider-play-btn" type="button">
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="1em" height="1em">
                                                                <g className="FaPlay">
                                                                    <path d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z" />
                                                                </g>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="live-casino-slider-content">
                                                    <div className="row-1">
                                                        <p className="casino-name">{name}</p>
                                                        <p className="tag isHot-tag">ฮอต</p>
                                                    </div>
                                                    <p className="casino-type">{providerName}</p>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </section>
                        </div>
                    )}

                    {/* ── provider-content (filter + tabs + grid) ── */}
                    <div className="provider-content">

                            {/* ── Sort + Search (bk8 .filter-container) ── */}
                            <div className="filter-container" style={{ background: 'transparent', borderTop: 'none', padding: 0, overflow: 'visible' }}>
                                <div className="sort-container" style={{ position: 'relative' }}>
                                    <div
                                        id="dropdownBtn"
                                        className={`standard-select ${this.state.sortOpen ? 'isOpen' : ''}`}
                                        onClick={() => this.setState({ sortOpen: !this.state.sortOpen })}
                                    >
                                        <span>{sortLabelMap[sortType]}</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.026 12.723" className={`drop-down-arrow ${this.state.sortOpen ? 'active' : ''}`} width="100%" height="100%">
                                            <g className="drop-down-arrow">
                                                <path className="st0" fill="#8697a2" d="M22.02596,1.95544c0,0.4981-0.1914,0.9981-0.5722,1.3789l-8.64462,8.64462c-0.4804,0.4824-1.1191,0.7441-1.7968,0.7441c-0.6797,0-1.3164-0.2656-1.795-0.7461L0.57282,3.33434c-0.7637-0.7617-0.7637-1.998,0-2.7617c0.7637-0.7636,2.002-0.7636,2.7637,0l7.67582,7.67582l7.67582-7.67582c0.7636-0.7636,2-0.7636,2.7656,0C21.83456,0.95354,22.02596,1.45354,22.02596,1.95544L22.02596,1.95544z" />
                                            </g>
                                        </svg>
                                    </div>
                                    {this.state.sortOpen && (
                                        <div style={{ position: 'absolute', top: '100%', left: 0, zIndex: 50, background: '#fff', borderRadius: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.18)', overflow: 'hidden', minWidth: '2.6rem', marginTop: 4 }}>
                                            {[['popular', 'เป็นที่นิยม'], ['az', 'ชื่อ A-Z'], ['za', 'ชื่อ Z-A']].map(([val, label]) => (
                                                <div
                                                    key={val}
                                                    onClick={() => this.setState({ sortType: val, sortOpen: false })}
                                                    style={{ padding: '9px 16px', fontSize: 13, color: sortType === val ? '#ff8a00' : '#333', fontWeight: sortType === val ? 600 : 400, cursor: 'pointer', whiteSpace: 'nowrap', background: sortType === val ? 'rgba(255,138,0,0.08)' : 'transparent' }}
                                                >
                                                    {label}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <div className="search-form-container">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.13323 19.00913" className="beta-search" width="100%" height="100%">
                                        <path fill="#04a9c2" d="M17.84436,17.32399l-4.091-4.09131c1.33264-1.45972,2.07007-3.33203,2.07007-5.32227c0-2.11328-0.823-4.1001-2.31726-5.59375c-1.49323-1.49426-3.48004-2.31714-5.59442-2.31714c-2.11432,0-4.10144,0.82288-5.59436,2.31689c-1.49463,1.4939-2.31763,3.48071-2.31763,5.59399c0,2.11401,0.823,4.10107,2.31726,5.59473c1.49359,1.49438,3.48071,2.31726,5.59473,2.31726c1.56732,0,3.06348-0.45447,4.34167-1.29724l4.19476,4.19507c0.38538,0.38538,1.01184,0.38599,1.39685,0.00098C18.22973,18.33619,18.22973,17.70948,17.84436,17.32399z M3.28699,12.53517c-1.23547-1.23438-1.91583-2.87695-1.91583-4.62476c0-1.74707,0.68036-3.38928,1.91614-4.62402c1.23413-1.23511,2.8764-1.91553,4.62445-1.91553c1.74774,0,3.39001,0.68042,4.62445,1.91577c1.23547,1.2345,1.91583,2.87671,1.91583,4.62378c0,1.7478-0.68036,3.39038-1.91614,4.62512c-1.23444,1.23523-2.87671,1.91541-4.62415,1.91541C6.16406,14.45094,4.52179,13.77076,3.28699,12.53517z" />
                                    </svg>
                                    <input
                                        type="text"
                                        id="filter"
                                        className="search-input"
                                        placeholder="ค้นหา"
                                        value={searchText || ''}
                                        onChange={(e) => this.setState({ searchText: e.target.value })}
                                    />
                                </div>
                            </div>

                            {/* ── Filter tabs (bk8: .standard-tab.provider-filter-tab) ── */}
                            <div className="standard-tab-container tab-container">
                                <div className="standard-tab provider-filter-tab">
                                    {this.renderMobileFilterTab("ALL", "ALL", "HTML5")}
                                    {this.renderMobileFilterTab("BACCARAT", "บาคาร่า", "baccarat")}
                                    {this.renderMobileFilterTab("SICBO", "ไฮโล", "sicBo")}
                                    {this.renderMobileFilterTab("ROULETTE", "รูเล็ต", "roulette")}
                                    {this.renderMobileFilterTab("DRAGONTIGER", "เสือ มังกร", "dragonTiger")}
                                    {this.renderMobileFilterTab("BLACKJACK", "แบล็คแจ็ค", "blackJack")}
                                    {this.renderMobileFilterTab("OTHER", "อื่นๆ", "others")}
                                </div>
                            </div>

                            {/* ── Game grid (bk8 .game-container > .game-box) ── */}
                            <div className="game-container">
                                {loadingGame ? (
                                    <p className="casino-mobile-loading">กำลังโหลดเกม...</p>
                                ) : mainGames.length > 0 ? (
                                    mainGames.map((game, index) => this.renderMobileGameCard(game, index))
                                ) : (
                                    <p className="casino-mobile-loading">ไม่พบเกม</p>
                                )}
                            </div>

                        </div>
                    </div>

                </div>
            );
        }

        /* ─── DESKTOP LAYOUT ─── */
        return (
            <>

                <div className="_productBannerContainer_1ma75_1 product-banner-container">
                    <div className="slick-slider slider slick-initialized">
                        <div className="slick-list">
                            <div
                                className="slick-track"
                                style={{
                                    width: "100%",
                                    opacity: 1,
                                    transform: "translate3d(0px, 0px, 0px)"
                                }}
                            >
                                <div
                                    data-index={0}
                                    className="slick-slide slick-active slick-current"
                                    tabIndex={-1}
                                    aria-hidden="false"
                                    style={{
                                        outline: "none",
                                        width: "100%"
                                    }}
                                >
                                    <div>
                                        <div
                                            className="_productBannerWrapper_1ma75_1 top top-provider-img"
                                            tabIndex={-1}
                                            style={{
                                                width: "100%",
                                                display: "inline-block"
                                            }}
                                        >
                                            <picture>
                                                <source
                                                    type="image/webp"
                                                    srcSet="https://s3.newworld.center/image/1f333c5d-213b-4c68-a3f2-0c65ad280aec.webp"
                                                />
                                                <img
                                                    src="https://s3.newworld.center/image/1f333c5d-213b-4c68-a3f2-0c65ad280aec.webp"
                                                    className="_productBanner_1ma75_1 provider-banner"
                                                    alt="banner-img"
                                                    onError={(e) => { e.target.style.display = 'none'; }}
                                                />
                                            </picture>

                                            <div className="_content_1ma75_25 top-provider-content ">
                                                <p className="_title_1ma75_48 provider-type">คาสิโนสด</p>

                                                <div className="_desc_1ma75_58 provider-desc">
                                                    <h4>เล่นเกมที่ให้บริการออนไลน์โดยดีลเลอร์มากประสบการณ์</h4>
                                                    <h5>ลงทะเบียนวันนี้เพื่อรับรางวัลใหญ่</h5>
                                                </div>
                                            </div>

                                            <div className="bk8-logo-container">
                                                <div className="logo-img" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mid" id="provider-box">
                    <ul className="provider-box">
                        {loadingProvider ? (
                            <li className="tab-header active">
                                <div className="tab-inner">
                                    <span>กำลังโหลดค่ายคาสิโน</span>
                                </div>
                            </li>
                        ) : categorylist.length > 0 ? (
                            categorylist.map((item, index) => this.renderProviderItem(item, index))
                        ) : (
                            <li className="tab-header active">
                                <div className="tab-inner">
                                    <span>ไม่พบค่ายคาสิโน</span>
                                </div>
                            </li>
                        )}
                    </ul>
                </div>

                <div className="standard-tab-container tab-container">
                    <div className="standard-tab">
                        <div className="tab-list">
                            {this.renderTabHeader("ALL", "ALL")}
                            {this.renderTabHeader("BACCARAT", "บาคาร่า")}
                            {this.renderTabHeader("SICBO", "ไฮโล")}
                            {this.renderTabHeader("ROULETTE", "รูเล็ต")}
                            {this.renderTabHeader("DRAGONTIGER", "เสือ มังกร")}
                            {this.renderTabHeader("BLACKJACK", "แบล็คแจ็ค")}
                            {this.renderTabHeader("OTHER", "อื่นๆ")}
                        </div>
                    </div>
                </div>


                <div className="bottom">
                    <div className="casino-content-container">
                        <div className="item-content">
                            {/* ── Left col: video + winner (span 1, CSS: grid-column span 1) ── */}
                            <div className="item-columns video-winner-container">
                                {this.renderVideoBox()}
                                {this.renderWinnerBox()}
                            </div>

                            {/* ── Right col: first 6 game cards (CSS: game-right-container = 2-col grid) ── */}
                            <div className="game-right-container">
                                {loadingGame ? (
                                    <div className="item-columns">
                                        <div className="bn-desc">
                                            <p className="name">กำลังโหลดเกม...</p>
                                        </div>
                                    </div>
                                ) : games.length > 0 ? (
                                    games.slice(0, 6).map((game, index) => this.renderGameCard(game, index))
                                ) : (
                                    <div className="item-columns">
                                        <div className="bn-desc">
                                            <p className="name">ไม่พบเกมคาสิโน</p>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* ── Bottom row: remaining games (CSS: grid-column 1/-1, 2-col grid) ── */}
                            {!loadingGame && games.length > 6 && (
                                <div className="bottom-game-list-container">
                                    {games.slice(6).map((game, index) => this.renderGameCard(game, index + 6))}
                                </div>
                            )}
                        </div>
                    </div>

                    {this.renderBestLiveSlider()}
                    {this.renderSummaryInfo()}
                </div>

            </>
        );
    }
}

export default App;